
(() => {
  function init() {
    document.querySelectorAll('.hm-night-queen').forEach(root => {
      if (root.dataset.hmReady) return;
      root.dataset.hmReady = 'true';
      const visibleControls = new Set();
      const buyingObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => { if (entry.isIntersecting) visibleControls.add(entry.target); else visibleControls.delete(entry.target); });
        document.body.classList.toggle('hm-nq-buying-visible', visibleControls.size > 0);
      });
      root.querySelectorAll('variant-picker,buy-buttons').forEach(el => buyingObserver.observe(el));
      if (document.documentElement.lang.startsWith('es')) {
        const labels = JSON.parse(root.querySelector('[data-hm-labels]').textContent);
        const localize = () => {
          observer.disconnect();
          const targets = document.querySelectorAll('a, .section-footer__title, .section-footer p, .hometitle, .jdgm-rev-widg__title, .jdgm-sort-dropdown-label, .jdgm-sort-dropdown option');
          targets.forEach(el => {
            if (el.closest('.jdgm-rev__body,.jdgm-rev__title') || el.children.length) return;
            const value = labels[el.textContent.trim()];
            if (value && el.textContent !== value) el.textContent = value;
          });
          document.querySelectorAll('.jdgm-prev-badge__text,.jdgm-rev-widg__summary-text').forEach(el => {
            const value = el.textContent.replace(/Based on/g,'Basado en').replace(/reviews/g,'opiniones').replace(/review\b/g,'opinión');
            if (value !== el.textContent) el.textContent = value;
          });
          document.querySelectorAll('[aria-label="See all reviews"]').forEach(el => el.setAttribute('aria-label', labels['See all reviews']));
          observer.observe(document.body,{childList:true,subtree:true});
        };
        let queued = false;
        const observer = new MutationObserver(() => {
          if (queued) return;
          queued = true;
          requestAnimationFrame(() => { queued = false; localize(); });
        });
        localize();
      }
      root.querySelectorAll('[data-hm-guide-link]').forEach(link => link.addEventListener('click', event => {
        const guide = root.querySelector('.hm-nq-guide');
        if (!guide) return;
        event.preventDefault();
        guide.open = true;
        guide.querySelector('summary').focus();
        guide.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      }));
      root.querySelectorAll('.hm-nq-units input').forEach(input => input.addEventListener('change', () => {
        const guide = input.closest('.hm-nq-guide');
        const inches = input.value === 'in';
        guide.querySelectorAll('[data-cm]').forEach(cell => {
          const number = Number(cell.dataset.cm);
          cell.textContent = inches ? (number / 2.54).toFixed(1) : String(number);
        });
        guide.querySelector('[data-hm-unit]').textContent = inches ? 'in' : 'cm';
      }));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

